import React, { useState, createRef } from 'react';
import {
    Card,
    Form,
    Input,
    Button,
    Slider,
    Rate,
    DatePicker,
    Select,
    Alert
} from 'antd';
import moment from 'moment';
import {
    HeartOutlined,
    StarFilled
} from '@ant-design/icons';

import {
    AccordionStep,
    RichTextInput,
    Upload
} from '../../../../../components';
import {
    form
} from '../../../../../assets/config';
import {
    disabledDate
} from '../../../../../assets/fns';
import {
    useFormProcess
} from '../../../../../hooks';

const ProjectBasicInformation = React.memo(({
    loading,
    value,
    fns,
    postProject,
    builders,
    ...props
}) => {

    const [formProcess, formProcessFns] = useFormProcess();

    const onSubmit = () => {
        const hasInvalidRera = (value.rera || []).some((item) => {
            const reraId = (item.rera_id || '').trim();
            const reraLabel = (item.label || '').trim();
            const hasQr = !!(((item.qr_code || [])[0] || {}).response || ((item.qr_code || [])[0] || {}).location);
            const hasAnyData = reraId !== '' || reraLabel !== '' || hasQr;
            return hasAnyData && reraId === '';
        });

        if (hasInvalidRera) {
            formProcessFns.setErrorMessage('RERA ID is mandatory for each RERA detail. QR code is optional.');
            return;
        }

        postProject(formProcessFns);
    }

    return (
        <AccordionStep {...props} displayName="Basic Information">
            <Card loading={loading}>
                <Form {...form.layout}>
                    {/* <Form.Item label="Location">
                        <Drawer
                            closable={false}
                            onClose={closeLocationDrawer}
                            visible={showLocationDrawer}
                            width="20rem"
                        >
                            <Space direction="vertical">
                                <p> 
                                    Please enter the URL copied from the 
                                    google map page for the given location
                                </p>
                                <Input />
                                <Button type="primary">
                                    Update
                                </Button>
                            </Space>
                        </Drawer>
                    </Form.Item> */}
                    <Form.Item label="RERA Details">
                        {(value.rera || []).map((reraItem, index) => (
                            <Card
                                key={`rera-${index}`}
                                size="small"
                                style={{ marginBottom: 12 }}
                            >
                                <Form.Item label={`RERA ID ${index + 1}`}>
                                    <Input
                                        value={reraItem.rera_id}
                                        onChange={(e) => fns.setReraId(index, e)}
                                    />
                                </Form.Item>
                                <Form.Item label="RERA Label">
                                    <Input
                                        value={reraItem.label}
                                        onChange={(e) => fns.setReraLabel(index, e)}
                                    />
                                </Form.Item>
                                <Form.Item label="RERA QR Code">
                                    <Upload
                                        limit={1}
                                        fileList={reraItem.qr_code}
                                        setFileList={(files) => fns.setReraQrCode(index, files)}
                                    />
                                </Form.Item>
                                <Button
                                    danger
                                    disabled={(value.rera || []).length === 1}
                                    onClick={() => fns.removeRera(index)}
                                >
                                    Remove RERA
                                </Button>
                            </Card>
                        ))}
                        <Button onClick={fns.addRera}>Add Another RERA</Button>
                    </Form.Item>
                    <Form.Item label="Price Per Square Feet">
                        <Input
                            type="number"
                            value={value.price_per_sq_ft}
                            onChange={fns.setPricePerSquareFeet}
                        />
                    </Form.Item>
                    <Form.Item label="Min Price">
                        <Input
                            type="number"
                            value={value.minimum_price}
                            onChange={fns.setMinPrice}
                        />
                    </Form.Item>
                    <Form.Item label="Max Price">
                        <Input
                            type="number"
                            value={value.maximum_price}
                            onChange={fns.setMaxPrice}
                        />
                    </Form.Item>
                    <Form.Item label="Area (in acres)">
                        <Input
                            type="number"
                            value={value.area}
                            onChange={fns.setArea}
                        />
                    </Form.Item>
                    <Form.Item label="Floors">
                        <Input
                            type="number"
                            value={value.floors}
                            onChange={fns.setFloors}
                        />
                    </Form.Item>
                    <Form.Item label="Towers">
                        <Input
                            type="number"
                            value={value.towers}
                            onChange={fns.setTowers}
                        />
                    </Form.Item>
                    <Form.Item label="Builder">
                        <Select
                            placeholder="Select a option and change input text above"
                            allowClear
                            value={value.builder}
                            onChange={fns.setBuilder}
                        >
                            {builders.map((builder) => {
                                return <Select.Option key={builder._id} value={builder._id}>{builder.name}</Select.Option>
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Posession Date">
                        <DatePicker
                            value={ value.possession_date ? moment(value.possession_date) : ''}
                            onChange={fns.setPosessionDate}
                        />
                    </Form.Item>
                    <Form.Item label="Posession Status">
                        <Select
                            placeholder="Select a option and change input text above"
                            onChange={fns.setPosessionStatus}
                            value={value.possession_status}
                            allowClear
                        >
                            <Select.Option value="New Launch">New Launch</Select.Option>
                            <Select.Option value="Mid Stage">Mid Stage</Select.Option>
                            <Select.Option value="Near Possession">Near Posession</Select.Option>
                            <Select.Option value="Ready To Move">Ready To Move</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="Posession Bar Progress">
                        <Slider
                            min={1}
                            max={10}
                            step={1}
                            value={value.possession_value}
                            // onChange={fns.setPosessionValue}
                        />
                    </Form.Item>

                    <Form.Item label="Rating">
                        <Rate
                            defaultValue={null}
                            count={5}
                            character={<StarFilled />}
                            value={value.rating}
                            onChange={fns.setRating}
                        />
                    </Form.Item>

                    <Form.Item label="Connectivity">
                        <Rate
                            defaultValue={null}
                            count={10}
                            character={<HeartOutlined />}
                            value={value.connectivity}
                            onChange={fns.setConnectivity}
                        />
                    </Form.Item>
                    <Form.Item label="Value For Money">
                        <Rate
                            defaultValue={null}
                            count={10}
                            character={<HeartOutlined />}
                            value={value.value_for_money}
                            onChange={fns.setValueForMoney}
                        />
                    </Form.Item>
                    <Form.Item label="Livability">
                        <Rate
                            defaultValue={null}
                            count={10}
                            character={<HeartOutlined />}
                            value={value.livability}
                            onChange={fns.setLivability}
                        />
                    </Form.Item>
                    <Form.Item label="Life Style">
                        <Rate
                            defaultValue={null}
                            count={10}
                            character={<HeartOutlined />}
                            value={value.life_style}
                            onChange={fns.setLifeStyle}
                        />
                    </Form.Item>
                    <Form.Item label="Project Highlights">
                        <RichTextInput
                            value={value.highlightSaved}
                            onChange={fns.updateHighlight}
                            />
                    </Form.Item>
                    <Form.Item label="About Project">
                        <RichTextInput
                            value={value.descriptionSaved}
                            onChange={fns.updateDescription}
                        />
                    </Form.Item>
                    <Form.Item {...form.tailLayout}>
                        <Button 
                            type="primary"
                            htmlType="submit"
                            loading={formProcess.loading}
                            onClick={onSubmit}
                        >
                            Save
                        </Button>
                    </Form.Item>
                    <Form.Item {...form.tailLayout}>
                        {formProcess.errorMsg && (
                            <Alert message={formProcess.errorMsg} type="error" />
                        )}
                    </Form.Item>
                </Form>
            </Card>
        </AccordionStep>
    )
});

const highlightRef = createRef();
const descriptionRef = createRef();

export function useProjectBasicInformation() {

    function getEmptyRera() {
        return {
            label: '',
            rera_id: '',
            qr_code: []
        };
    }

    const [value, setValue] = useState({
        price_per_sq_ft: '',
        minimum_price: '',
        maximum_price: '',
        area: '',
        floors: '',
        towers: '',
        possession_date: '',
        possession_value: '',
        possession_status: '',
        rating: '',
        connectivity: '',
        value_for_money: '',
        livability: '',
        life_style: '',
        highlight: '',
        description: '',
        builder: '',
        rera: [getEmptyRera()]
    });

    function updateDataFromAPI(data) {
        const decisionDrivers = data.decision_drivers || {};
        const parsedRera = (data.rera || [])
            .map((reraItem, index) => {
                const qrCode = reraItem.qr_code || {};
                const hasQrCode = qrCode.location && qrCode.image_key;

                return {
                    label: reraItem.label || '',
                    rera_id: reraItem.rera_id || '',
                    qr_code: hasQrCode ? [{
                        uid: qrCode.image_key || `rera-qr-${index}`,
                        url: qrCode.location,
                        response: {
                            location: qrCode.location,
                            image_key: qrCode.image_key
                        }
                    }] : []
                };
            })
            .filter(item => item.rera_id || item.label || item.qr_code.length > 0);

        if (parsedRera.length === 0 && data.rear_id) {
            parsedRera.push({
                label: '',
                rera_id: data.rear_id,
                qr_code: []
            });
        }

        setValue({
            price_per_sq_ft: data.price_per_sq_ft || '',
            minimum_price: data.minimum_price || '',
            maximum_price: data.maximum_price || '',
            area: data.area ?? '',
            floors: data.floors ?? '',
            towers: data.towers ?? '',
            connectivity: decisionDrivers.connectivity || '',
            value_for_money: decisionDrivers.value_for_money || '',
            life_style: decisionDrivers.life_style || '',
            livability: decisionDrivers.livability || '',
            highlightSaved: data.highlight || '',
            descriptionSaved: data.description || '',
            possession_date: data.possession_date || '',
            possession_value: data.possession_value || '',
            possession_status: data.possession_status || '',
            builder: data.builder || '',
            rating: data.rating || '',
            rera: parsedRera.length > 0 ? parsedRera : [getEmptyRera()]
        });
    }

    function setBuilder(value) {
        setValue(d => ({ ...d, builder: value }));
    }

    function setReraId(index, e) {
        const reraId = e.target.value;
        setValue(state => ({
            ...state,
            rera: (state.rera || []).map((item, itemIndex) => {
                if (itemIndex === index) {
                    return {
                        ...item,
                        rera_id: reraId
                    };
                }
                return item;
            })
        }));
    }

    function setReraLabel(index, e) {
        const label = e.target.value;
        setValue(state => ({
            ...state,
            rera: (state.rera || []).map((item, itemIndex) => {
                if (itemIndex === index) {
                    return {
                        ...item,
                        label
                    };
                }
                return item;
            })
        }));
    }

    function setReraQrCode(index, fileList) {
        setValue(state => ({
            ...state,
            rera: (state.rera || []).map((item, itemIndex) => {
                if (itemIndex === index) {
                    return {
                        ...item,
                        qr_code: fileList
                    };
                }
                return item;
            })
        }));
    }

    function addRera() {
        setValue(state => ({
            ...state,
            rera: [...(state.rera || []), getEmptyRera()]
        }));
    }

    function removeRera(index) {
        setValue(state => {
            const nextRera = (state.rera || []).filter((_, itemIndex) => itemIndex !== index);
            return {
                ...state,
                rera: nextRera.length > 0 ? nextRera : [getEmptyRera()]
            };
        });
    }

    function setPricePerSquareFeet(e) {
        const value = e.target.value;
        setValue(d => ({ ...d, price_per_sq_ft: value }));
    }

    function setMinPrice(e) {
        const value = e.target.value;
        setValue(d => ({ ...d, minimum_price: value }));
    }

    function setMaxPrice(e) {
        const value = e.target.value;
        setValue(d => ({ ...d, maximum_price: value }));
    }

    function setArea(e) {
        const value = e.target.value;
        setValue(d => ({ ...d, area: value }));
    }

    function setFloors(e) {
        const value = e.target.value;
        setValue(d => ({ ...d, floors: value }));
    }

    function setTowers(e) {
        const value = e.target.value;
        setValue(d => ({ ...d, towers: value }));
    }

    function setPosessionDate(e) {
        const value = e ? e.toISOString() : null;
        setValue(d => ({ ...d, possession_date: value }));
    }

    function setPosessionStatus(status) {
        const posessionValue = {
            'New Launch': 3,
            'Mid Stage': 5,
            'Near Possession': 8,
            'Ready To Move': 10
        };

        setValue(d => ({ ...d, possession_status: status, possession_value: posessionValue[status] }));
    }
    function setPosessionValue(value){
        setValue(d => ({ ...d, possession_value: value }));
    }

    function setRating(value) {
        setValue(d => ({ ...d, rating: value}));
    }

    function setConnectivity(value){
        setValue(d => ({ ...d, connectivity: value }))
    }

    function setValueForMoney(value) {
        setValue(d => ({ ...d, value_for_money: value }))
    }

    function setLivability(value) {
        setValue(d => ({ ...d, livability: value }))
    }

    function setLifeStyle(value) {
        setValue(d => ({ ...d, life_style: value }))
    }

    function updateHighlight(value) {
        highlightRef.current = value;
    }

    function updateDescription(value) {
        descriptionRef.current = value;
    }

    function formatData() {
        const {
            highlightSaved,
            descriptionSaved,
            connectivity,
            livability,
            life_style,
            value_for_money,
            ..._postData
        } = value;

        const formattedRera = (_postData.rera || [])
            .filter(item => (item.rera_id || '').trim() !== '')
            .map(item => {
                const qrFile = (item.qr_code || [])[0];
                const qrPayload = qrFile ? (qrFile.response || qrFile) : null;
                const qrCode = qrPayload && qrPayload.location ? {
                    location: qrPayload.location,
                    image_key: qrPayload.image_key || qrPayload.key || ''
                } : {};

                return {
                    label: item.label || '',
                    rera_id: item.rera_id,
                    qr_code: qrCode
                };
            });

        function parseOptionalNumber(numberValue) {
            if (numberValue === '' || numberValue === null || typeof numberValue === 'undefined') {
                return undefined;
            }
            const parsed = Number(numberValue);
            return Number.isNaN(parsed) ? undefined : parsed;
        }

        return {
            ..._postData,
            possession_date: _postData.possession_date || '',
            area: parseOptionalNumber(_postData.area),
            floors: parseOptionalNumber(_postData.floors),
            towers: parseOptionalNumber(_postData.towers),
            rear_id: (formattedRera[0] || {}).rera_id || '',
            rera: formattedRera,
            highlight: highlightRef.current || '',
            description: descriptionRef.current || '',
            decision_drivers: {
                connectivity,
                livability,
                life_style,
                value_for_money
            }
        }
    }

    return [
        value,
        {
            updateDataFromAPI,
            setReraId,
            setReraLabel,
            setReraQrCode,
            addRera,
            removeRera,
            setPricePerSquareFeet,
            setMinPrice,
            setMaxPrice,
            setArea,
            setFloors,
            setTowers,
            setPosessionDate,
            setPosessionStatus,
            setPosessionValue,
            setRating,
            setConnectivity,
            setValueForMoney,
            setLivability,
            setLifeStyle,
            formatData,
            updateHighlight,
            updateDescription,
            setBuilder
        }
    ];
}

ProjectBasicInformation.useProjectBasicInformation = useProjectBasicInformation;

export default ProjectBasicInformation;
